import React from 'react';
import ProductCard from './ProductCard';
import BackgroundText from './BackgroundText';

import styles from './assets/styles/main.css';

const Home = () => {
	return(

		<div id = 'home'>
			<BackgroundText text = {'React Ecommerce Store'} />
			<div className = 'container'>
				<ProductCard />				
			</div>
		</div>

		);
};

export default Home;